import { CreateToolOrderResult, ToolCategory, ToolOrder, ToolRoom } from '@bechtel/ht-types';

export interface CreateReservationProps {
  onClose?: () => void;
  visible?: boolean;
  draftToolOrder?: ToolOrder;
  toolRoomId?: string;
  toolRoom?: ToolRoom;
}

export interface CreateReservationData {
  createToolOrder: CreateToolOrderResult;
}

export interface ToolCategoryListData {
  toolCategoryGroupByName: ToolCategory[];
}

export enum OrderCreationSteps {
  CREATE,
  CONTINUE,
  CONFIRMATION,
}
export const reservationMutationRefetchQueries = ['SearchToolOrders', 'ToolOrderStats'];
